import React from 'react';
import cn from 'classnames';

import ArrowDownIcon from 'widget/shared/icons/ArrowDownIcon';
import { IconSize } from 'widget/shared/icons/BaseIcon';

import styles from './ScrollToBottomButton.module.scss';

type ScrollToBottomButtonProps = {
  count: number;
  onClick: () => void;
  className?: string;
};

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
  count,
  onClick,
  className
}) => {
  return (
    <button
      className={cn(styles['button'], className)}
      onClick={onClick}
      type="button"
      aria-label={`${count} новых сообщений, прокрутить вниз`}
    >
      {count > 0 && (
        <span className={styles['button__badge']}>
          {count > 99 ? '99+' : count}
        </span>
      )}
      <ArrowDownIcon size={IconSize.XS} className={styles['button__icon']} />
    </button>
  );
};

export default React.memo(ScrollToBottomButton);
